// Exports
export default {
	"OutgoingCallStatus": "OutgoingCallStatus_U7H6+",
	"OutgoingCallStatus__calleeName": "OutgoingCallStatus__calleeName_S6yUd",
	"OutgoingCallStatus__callStatus": "OutgoingCallStatus__callStatus_EZNDG"
};
